import { 
  getExamData as getExamDataFromFirebase,
  getMockTests as getMockTestsFromFirebase,
  getQuestionsByTopicFromBank,
  getQuestionsBySubjectFromBank,
  getMixedQuestionsFromBank
} from '../firebase/collections';

// Firebase-based exam data functions
export const getExamData = async (examId) => {
  try {
    const result = await getExamDataFromFirebase(examId);
    if (result.success) {
      return result.data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

// Firebase-based mock tests functions
export const getMockTests = async (examId) => {
  try {
    // Use the enhanced function that includes both mockTests and tests collections
    const { getMockTestsEnhanced } = await import('../firebase/collections');
    const result = await getMockTestsEnhanced(examId);
    if (result.success) {
      return result.data;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

// Firebase-based question functions
export const getQuestionsByTopic = async (topic, count = 10) => {
  try {
    const result = await getQuestionsByTopicFromBank(topic, count);
    if (result.success) {
      return safeQuestionData(result.data);
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const getQuestionsBySubject = async (subject, count = 10) => {
  try {
    const result = await getQuestionsBySubjectFromBank(subject, count);
    if (result.success) {
      return result.data;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const getMixedQuestions = async (count = 20) => {
  try {
    const result = await getMixedQuestionsFromBank(count);
    if (result.success) {
      return result.data;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

// Safe question data processing utilities
export const safeQuestionData = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (typeof data === 'object' && data.topics) {
    // Handle nested topic structure
    const flattened = [];
    Object.entries(data.topics).forEach(([topic, questions]) => {
      if (Array.isArray(questions)) {
        questions.forEach(q => {
          if (q && typeof q === 'object') {
            flattened.push({ ...q, topic: q.topic || topic });
          }
        });
      }
    });
    return flattened;
  }
  return [];
};

export const safeProcessQuestions = (questions, processor) => {
  const safeQuestions = safeQuestionData(questions);
  try {
    return safeQuestions.map(processor);
  } catch (error) {
    return [];
  }
};

export const safeForEachQuestions = (questions, callback) => {
  const safeQuestions = safeQuestionData(questions);
  try {
    safeQuestions.forEach(callback);
  } catch (error) {
    }
};

// Helper function to check if Firebase data is available
export const isFirebaseDataAvailable = async () => {
  try {
    const examData = await getExamData('cat');
    const mockTests = await getMockTests('cat');
    const questions = await getMixedQuestions(1);
    
    return {
      available: !!(examData && mockTests.length > 0 && questions.length > 0),
      hasExamData: !!examData,
      hasMockTests: mockTests.length > 0,
      hasQuestions: questions.length > 0
    };
  } catch (error) {
    return {
      available: false,
      hasExamData: false,
      hasMockTests: false,
      hasQuestions: false,
      error
    };
  }
};
